module.exports = __webpack_public_path__ + "static/img/proceedingTab.9e3ad20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/proceedingTab.jpg
// module id = +f9A
// module chunks = 4